import { render, staticRenderFns } from "./ModalShowMovie.vue?vue&type=template&id=5d182dda&scoped=true&lang=pug"
import script from "./ModalShowMovie.vue?vue&type=script&lang=ts"
export * from "./ModalShowMovie.vue?vue&type=script&lang=ts"
import style0 from "./ModalShowMovie.vue?vue&type=style&index=0&id=5d182dda&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d182dda",
  null
  
)

export default component.exports